import { ModalProps } from './modal.props';
import { CSSTransition } from 'react-transition-group';
import React, { useEffect, useRef, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import { useModalStyles } from './modal.styles';
import ReactDOM from 'react-dom';

export const ModalMolecule = (props: ModalProps) => {
  const parentRef = useRef<Element>();
  const ref = useRef(null);
  useOnClickOutside(ref, () => closeModal());

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    parentRef.current = document.getElementsByTagName('body')[0];
    setMounted(true);
  }, []);

  const classes = useModalStyles();

  const closeModal = () => {
    if (props.closingEnabled) {
      props.closeModal();
    }
  };

  return mounted
    ? ReactDOM.createPortal(
        <>
          <CSSTransition
            mountOnEnter
            unmountOnExit
            in={props.opened}
            timeout={250}
            classNames={'modal-transition'}
          >
            <div
              data-cy="modal-organism"
              ref={ref}
              className={`fixed left-0 right-0  shadow-md mx-auto z-60 w-11/12 rounded-lg lg:w-full lg:max-w-screen-md bg-white overflow-y-scroll ${props.className} ${classes['modal-transition']}`}
            >
              {props.children}
              {props.closingEnabled && (
                <div
                  onClick={() => closeModal()}
                  className="close-icon cursor-pointer absolute top-7 right-7 w-3 h-3"
                >
                  <img
                    className=""
                    src={props.closeIconImgSrc}
                    alt="Close icon"
                  />
                </div>
              )}
            </div>
          </CSSTransition>
          <CSSTransition
            mountOnEnter
            unmountOnExit
            in={props.opened}
            timeout={250}
            classNames={'bg-layer-transition'}
          >
            <div
              className={`bg-layer cursor-pointer fixed z-40 top-0 left-0 w-full h-full bg-black ${classes['bg-layer-transition']}`}
            />
          </CSSTransition>
        </>,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        parentRef.current
      )
    : null;
};

ModalMolecule.defaultProps = {
  closingEnabled: true,
  closeIconImgSrc: '/images/icons/close-round-dark.png',
};
